// vendor
import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';
// router-store
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { featureFlagReducer, FeatureFlagState } from './feature-flag.reducer';
import { RouterReducerState, routerReducer, RouterStateSerializer } from '@ngrx/router-store';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
}

export interface State {
  routerReducer: RouterReducerState<RouterStateUrl>;
  featureFlag: FeatureFlagState;
}

export const appReducers: ActionReducerMap<State> = {
  routerReducer: routerReducer,
  featureFlag: featureFlagReducer,
};

export const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('routerReducer');

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;

    return { url, queryParams, params };
  }
}
